module.exports = __webpack_public_path__ + "static/img/qrcode_gz.13cb3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima/qrcode_gz.jpg
// module id = H+T7
// module chunks = 124